<template>
  <div>
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";

exportingInit(Highcharts);
export default {
  props: ["data"],
  computed: {
    chartOptions: function() {
      return {
        chart: {
          type: "area",
          backgroundColor: null,
        },
        accessibility: {
          //   description:
          //     "Image description: An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.",
        },
        title: {
          text: "",
        },
        subtitle: {
          text: '',
        },
        credits: {
            enabled: false
        },
        xAxis: {
          categories: this.data ? Object.keys(this.data) : [],
          allowDecimals: false,
          labels: {
            style: {
              color: '#fff',
              fontWeight: 'bold',
            }
          },
          accessibility: {
            rangeDescription: "Range: 0 to 1000.",
          },
        },
        legend: {
          enabled: false,
        },
        yAxis: {
            title: {
              text: "",
            },
          labels: {
            formatter: function () {
              return this.value / 1000 + "k";
            },
            style: {
              color: '#fff',
              fontWeight: 'bold',
            }
          },
        },
        exporting: { enabled: false },
        tooltip: {
          pointFormat:
            "Case Retained: <b>{point.y:,.0f}</b><br/>Date: <b>2022-07-{point.x}</b>",
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
            borderWidth: 0,
            lineColor: 'transparent',
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1},
              stops: [
                  [0, 'rgba(225, 15, 255, 1)'],
                  [1, 'rgba(135, 107, 253, 0.18)']
              ]
            },
          },
        },
        series: [
          {
            name: "",
            data: this.data ? Object.values(this.data) : [],
          },
        ],
      }
    }
  }
};
</script>
